// extracted by mini-css-extract-plugin
export default {"processingResultsPage__header":"styles_processing-results-page__header__DrURV","processingResultsPage__header_hidden":"styles_processing-results-page__header_hidden__fZtzS"};